import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import DropDown from '@/common/dropdown.vue';
import { validateTaxNumber, validateEmail } from '@/tools/regexp';
import { saveInvoice as _saveInvoice, invoiceList, searchInvoiceName, searchInvoiceNo, pageVisit as _pageVisit, getDataInvoice } from '@/services/http';
import { readCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.form = {
      id: '',
      // 所选发票类型(1、个人发票2、公司增值税电子普票3、增值税电子专票)
      invoiceType: 1,
      invoiceName: '',
      invoiceNo: '',
      companyAddress: '',
      bankNo: '',
      telephone: '',
      bank: '',
      equip: '',
      version: '',
      companyId: 1,
      email: ''
    };
    _this.loading = false;
    _this.companyList = [];
    _this.rules = {
      invoiceName: [{
        required: true,
        message: '请填写名称',
        trigger: 'blur'
      }],
      companyAddress: [{
        required: true,
        message: '请填写注册地址',
        trigger: 'blur'
      }],
      telephone: [{
        required: true,
        message: '请填写电话号码',
        trigger: 'blur'
      }],
      invoiceNo: [{
        required: true,
        validator: validateTaxNumber,
        trigger: 'blur'
      }],
      bankNo: [{
        required: true,
        message: '请填写银行账号',
        trigger: 'blur'
      }],
      bank: [{
        required: true,
        message: '请填写开户行',
        trigger: 'change'
      }],
      email: [{
        required: true,
        validator: validateEmail,
        trigger: 'blur'
      }]
    };
    _this.options = [];
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.setInvoice();
      this.pageVisit();
    }
  }, {
    key: "selectType",
    value: function selectType(status, type) {
      if (!(status === 2 && this.form.invoiceType === 3 && type)) {
        this.form.invoiceType = status;
        var form = this.$refs.form;
        form.clearValidate();
      }
    }
    // 模糊搜索公司
  }, {
    key: "searchCompany",
    value: function () {
      var _searchCompany = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(queryString, cb) {
        var res, arr;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.next = 3;
              return searchInvoiceName({
                name: queryString
              });
            case 3:
              res = _context.sent;
              if (res.data.code === 100) {
                arr = res.data.data.map(function (element) {
                  return {
                    id: element.id,
                    value: element.entname
                  };
                });
                cb(arr);
              }
              this.loading = false;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function searchCompany(_x, _x2) {
        return _searchCompany.apply(this, arguments);
      }
      return searchCompany;
    }() // 根据公司名称查询税号
  }, {
    key: "searchNo",
    value: function () {
      var _searchNo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(item) {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return searchInvoiceNo({
                id: item.id
              });
            case 2:
              res = _context2.sent;
              this.form.invoiceNo = res.data.data.taxNumber;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function searchNo(_x3) {
        return _searchNo.apply(this, arguments);
      }
      return searchNo;
    }()
  }, {
    key: "setInvoice",
    value: function () {
      var _setInvoice = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var ID, res, obj;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              ID = this.$route.query.id;
              if (!ID) {
                _context3.next = 7;
                break;
              }
              _context3.next = 4;
              return invoiceList({
                pageNo: 1,
                pageSize: 40,
                companyId: 1
              });
            case 4:
              res = _context3.sent;
              obj = res.data.data.filter(function (e) {
                return e.id === Number(ID);
              })[0];
              this.form = obj;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function setInvoice() {
        return _setInvoice.apply(this, arguments);
      }
      return setInvoice;
    }() // 保存发票信息
  }, {
    key: "saveInvoice",
    value: function () {
      var _saveInvoice2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this2 = this;
        var anchor, form;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              anchor = readCookie('anchor');
              form = this.$refs.form;
              if (this.form.invoiceType === 1) {
                this.form = {
                  id: this.form.id,
                  invoiceType: 1,
                  invoiceName: this.form.invoiceName,
                  telephone: this.form.telephone,
                  email: this.form.email,
                  equip: '',
                  version: '',
                  invoiceNo: '',
                  companyAddress: '',
                  bankNo: '',
                  bank: '',
                  companyId: 1
                };
              } else if (this.form.invoiceType === 2) {
                this.form = {
                  id: this.form.id,
                  // 所选发票类型(1、个人发票2、公司增值税电子普票3、增值税电子专票)
                  invoiceType: 2,
                  invoiceName: this.form.invoiceName,
                  invoiceNo: this.form.invoiceNo,
                  email: this.form.email,
                  src: anchor ? anchor.src ? anchor.src : 2 : 4,
                  equip: anchor ? anchor.equip : 4,
                  version: anchor ? anchor.version : '',
                  companyId: 1
                };
              }
              form.validate(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(valid) {
                  var res;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!valid) {
                          _context4.next = 5;
                          break;
                        }
                        _context4.next = 3;
                        return _saveInvoice(_this2.form);
                      case 3:
                        res = _context4.sent;
                        if (res.data.code === 100) {
                          getDataInvoice({
                            src: anchor ? anchor.src ? anchor.src : 2 : 4,
                            equip: anchor ? anchor.equip : 4,
                            version: anchor ? anchor.version : '',
                            model: anchor ? anchor.model : '',
                            equipVersion: anchor ? anchor.equipVersion : '',
                            equipMeid: anchor ? anchor.equipMeid : '',
                            eventNo: '3.3.1.0.0.0.1',
                            invoiceType: _this2.form.invoiceType === 1 ? 1 : 2,
                            companyId: 1
                          });
                          _this2.$message.success('保存成功！');
                          _this2.$router.back();
                        } else {
                          _this2.$message.error(res.data.message);
                        }
                      case 5:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x4) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function saveInvoice() {
        return _saveInvoice2.apply(this, arguments);
      }
      return saveInvoice;
    }() // 访问页面数据埋点
  }, {
    key: "pageVisit",
    value: function pageVisit() {
      var anchor = readCookie('anchor');
      _pageVisit({
        pageType: 14,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        companyId: 1
      });
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Price: Price,
    Footer: Footer,
    DropDown: DropDown,
    NavMenu: NavMenu
  }
})], default_1);
export default default_1;